import { defineMessages } from 'react-intl';

export const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successPill: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	queueFiltersLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue.card-title',
		defaultMessage: 'Create queue',
		description: 'Card title when creating a JSM queue; name is the queue name',
	},
	confirmButton: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue.confirm-button',
		defaultMessage: 'Create',
		description: 'Label for the confirm button when creating a JSM queue',
	},
	expandBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue.expand-body-content',
		defaultMessage: 'Show more',
		description:
			'Button label to expand the card content area when text exceeds the visible height',
	},
	collapseBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue.collapse-body-content',
		defaultMessage: 'Show less',
		description:
			'Button label to collapse the card content area after it was expanded for long text',
	},
	successPill: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue.success-pill',
		defaultMessage: `You've created "{name}"`,
		description: 'Pill message shown after create JSM queue succeeds; name is the queue name',
	},
	queueFiltersLabel: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue.queue-filters-label',
		defaultMessage: 'JQL queue filters',
		description: 'Label for the queue filters in the create queue card body',
	},
});
